<template lang="pug">
#AddBoleta
    div
      //- BOTON AGREGAR BOLETA
      //-Agregar boleta solo cuando es garantia, y todos los usuarios.
      button.change-button(
        :disabled="disabled || loading"
        title="Agregar boleta"
        @click="showModal()"
        )
        | Agregar Boleta
        b-spinner(v-if="loading" class="ml-2" variant="white" small)
      SamtekModal(
        v-model="showModalBoleta" 
        title="Ingresar boleta" 
        size="lg"
        @shown="onModalShown"
        @hide="onModalHide"
        :hideFooter="true"
      )
        OTUploads(:ot="ot" fileNamePattern="boleta" :attachmentType="ARCHIVO_ADJUNTO_TIPO.BOLETA" :limitToOne="true" @done="handleDone")
        template(#modal-footer='{ ok, cancel, hide }')
          b-button.btn-samtek-secondary(size='sm' variant='light' @click='hideModal()') Cancelar
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import LoadingButtonMixin from '@/mixins/LoadingButtonMixin'
import { ARCHIVO_ADJUNTO_TIPO } from '@/utils/enums'
import OTUploads from '../OTUploads.vue'

export default {
  name: 'ActionAddBoleta',
  mixins: [LoadingButtonMixin],
  components: {
    OTUploads,
    SamtekModal: () => import('@/components/Common/SamtekModal.vue'),
  },
  props: ['disabled'],
  data() {
    return {
      showModalBoleta: false,
    }
  },
  created() {
    this.getOT(this.$attrs.ot.ot)
  },
  methods: {
    ...mapActions('OTStore', ['uploadFile', 'getOT']),
    showModal() {
      // Activar loading inmediatamente para prevenir múltiples clics
      this.startLoading()
      this.showModalBoleta = true
    },
    hideModal() {
      this.showModalBoleta = false
      // El loading se detendrá en onModalHide
    },
    onModalShown() {
      // Modal está completamente abierto, detener el loading de apertura
      this.stopLoading()
    },
    onModalHide() {
      // Se ejecuta cuando el modal se cierra por cualquier razón
      this.stopLoading()
    },
    async handleDone() {
      try {
        await this.executeWithLoading(async () => {
          this.$bvToast.toast('Archivos subidos correctamente', {
            variant: 'success',
          })
          await new Promise((resolve) => setTimeout(resolve, 500))
          this.$emit('changed')
        })
        // Solo cerrar el modal después de que todo esté completo
        this.showModalBoleta = false
      } catch (error) {
        console.error('Error al subir archivos:', error)
        this.$bvToast.toast('Error al subir archivos', {
          variant: 'danger',
        })
      }
    },
  },
  computed: {
    ...mapGetters('OTStore', ['ot', 'statusRequest']),
    ARCHIVO_ADJUNTO_TIPO: () => ARCHIVO_ADJUNTO_TIPO,
  },
}
</script>
